module.exports = __webpack_public_path__ + "static/logo-light.ddb86a2f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-light.svg
// module id = 474
// module chunks = 35783957827783